/* eslint-disable max-len */
import React from 'react';
import store from 'store/Store';

import actions from 'actions/Actions';
import passkeysActions from 'actions/PasskeysActions';

import BaseClass from 'components/BaseClass';
import LegacyGrid from 'components/LegacyGrid/LegacyGrid';
import InfoButton from 'components/InfoButton';
import {
    Button, Divider, Link, Text
} from 'components/ui';

import dateUtils from 'utils/Date';
import { wrapComponent } from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import mediaUtils from 'utils/Media';
import passkeysUtils from 'utils/passkeys';
import { APP_TEXT } from 'constants/passkeys';
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import authenticationUtils from 'utils/Authentication';

const { showPasskeysInfoModal } = actions;
const { getLocalisedDataFromResource } = LanguageLocaleUtils;
import AccountPasskeysEN from 'components/RichProfile/MyAccount/AccountInfo/AccountPasskeys/locales/AccountPasskeys_en_US';
import AccountPasskeysFR from 'components/RichProfile/MyAccount/AccountInfo/AccountPasskeys/locales/AccountPasskeys_fr_CA';
const getText = getLocalisedDataFromResource(AccountPasskeysEN, AccountPasskeysFR);
const { Media } = mediaUtils;

class AccountPasskeys extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            optinEnabled: false,
            passkeyIdThisDevice: null
        };
    }

    componentDidUpdate(prevProps) {
        const { isEditMode, setEditSection, passkeys } = this.props;

        if (isEditMode && passkeys?.length === 0) {
            setEditSection('');
        }

        if (prevProps.passkeys?.length !== passkeys?.length) {
            this.handleChangePasskeyInfo();
        }
    }

    componentDidMount() {
        this.handlePassKeyInfo();
    }

    handlePassKeyInfo = async (hasIdentity = false) => {
        const passkeyIdThisDevice = await passkeysUtils.isPasskeyExistsInCurrentDevice(hasIdentity || this.props.hasIdentity);
        const optinEnabled = !(await passkeysUtils.isPasskeyDisabled(true));
        this.setState({ optinEnabled, passkeyIdThisDevice });
    };

    handleChangePasskeyInfo = async () => {
        const isLoadedPasskeys = true;
        const passkeyIdThisDevice = await passkeysUtils.isPasskeyExistsInCurrentDevice(this.props.hasIdentity, this.props.passkeys, isLoadedPasskeys);
        this.setState({ passkeyIdThisDevice });
    };

    handleCloseButtonClick = () => {
        this.props.setEditSection('');
    };

    handleEditLinkClick = () => {
        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
            data: {
                pageName: anaConsts.PAGE_NAMES.ACC_SETTING_PASSKEY_EDIT,
                linkData: anaConsts.LinkData.ACC_SETTING_PASSKEY_EDIT,
                pageType: anaConsts.PAGE_TYPES.USER_PROFILE,
                pageDetail: anaConsts.PAGE_DETAIL.MY_ACCOUNT
            }
        });
        this.props.setEditSection('passkeys');
    };

    handleInfoButtonClick = () => {
        store.dispatch(showPasskeysInfoModal({ isOpen: true }));
    };

    sephoraDeviceText = passkey => {
        const thisDeviceText = this.state.passkeyIdThisDevice === passkey?.passkeyId ? ` - ${getText('thisDevice')}` : '';

        return passkey?.metaInfo?.browser !== APP_TEXT ? getText('browser') + thisDeviceText : getText('sephoraAppText');
    };

    handleRemovePasskeysLinkClick = passkey => {
        const message = getModalText => (
            <div>
                {getModalText('pleaseConfirmYouWantToRemove')}{' '}
                <strong>{`${passkey?.metaInfo?.deviceName} ${this.sephoraDeviceText(passkey)}` || ''}</strong>{' '}
                {getModalText('passkeyFromYourAccount')}
            </div>
        );

        return () => {
            const { firstName, lastName } = this.props.user;
            const userData = { firstName: firstName, lastName: lastName };
            passkeysActions.openRemovePasskeysModal(this.props.passkeys, passkey, message, userData);
        };
    };

    renderCreateButton = () => {
        return this.state.optinEnabled && !this.state.passkeyIdThisDevice && !Sephora.isAgent ? (
            <Button
                key='create_passkeys_action'
                data-at={Sephora.debug.dataAt('myaccount_passkey_create_button')}
                marginLeft={[0, 4]}
                marginTop={[4, 0]}
                width={['100%', '12em']}
                onClick={this.handleCreatePasskey}
                variant='primary'
            >
                {getText('create')}
            </Button>
        ) : null;
    };

    renderCancelButton = () => {
        return (
            <Button
                key='cancel_passkeys_action'
                data-at={Sephora.debug.dataAt('myaccount_cancel_button')}
                width={['100%', '12em']}
                onClick={this.handleCloseButtonClick}
                variant='secondary'
            >
                {getText('cancel')}
            </Button>
        );
    };

    renderPasskeys = () => {
        const isMobile = Sephora.isMobile();

        return this.props?.passkeys?.map(passkey => (
            <LegacyGrid.Cell
                key={passkey.passkeyId}
                marginBottom={4}
                width={isMobile ? 'fill' : 'fit'}
            >
                <LegacyGrid
                    fill={!isMobile}
                    gutter={2}
                    alignItems='center'
                >
                    <LegacyGrid.Cell width={isMobile ? 'fill' : 'fill'}>
                        <Text is='p'>{`${passkey?.metaInfo?.deviceName} ${this.sephoraDeviceText(passkey)}`}</Text>

                        <Text
                            color='gray'
                            is='p'
                        >
                            {getText('createdOn')} {passkey.created ? dateUtils.getPromiseDate(passkey.created, true) : ''}
                        </Text>
                    </LegacyGrid.Cell>

                    {!Sephora.isAgent && (
                        <LegacyGrid.Cell
                            textAlign='right'
                            width={isMobile ? 'fit' : 'fit'}
                        >
                            <Link
                                color='blue'
                                paddingY={2}
                                marginY={-2}
                                onClick={this.handleRemovePasskeysLinkClick(passkey)}
                                data-at={Sephora.debug.dataAt('account_passkey_remove_button')}
                            >
                                {getText('remove')}
                            </Link>
                        </LegacyGrid.Cell>
                    )}
                </LegacyGrid>
            </LegacyGrid.Cell>
        ));
    };

    handleCreatePasskey = async () => {
        const { login } = store.getState().user || {};
        this.passKeyCreateOptin(login);
    };

    passKeyCreateOptin = async login => {
        store.dispatch(
            actions.showPasskeyOptinModal({
                isOpen: true,
                email: login,
                passkeyType: 'optinCreateAccount',
                placement: 'account settings',
                successCallback: async params => {
                    if (!params?.dismissed) {
                        authenticationUtils.updateProfileStatus({
                            hasIdentity: [true]
                        });
                        this.handlePassKeyInfo(true);
                    }
                }
            })
        );
    };

    renderPasskeyHeader = () => {
        if (!passkeysUtils.isPasskeyEnabled()) {
            return null;
        }

        const activePasskeysText = getText('activePasskeys', [this.props.passkeys.length]);
        const [prefix = '', highlighted = '', suffix = ''] = activePasskeysText.split('*');
        const highlightedWords = highlighted.split(' ');
        const lastHighlightedWord = highlightedWords.pop();
        const leadingHighlightedText = highlightedWords.join(' ');

        return (
            <>
                {prefix}
                <Text
                    is='span'
                    fontWeight='bold'
                >
                    {leadingHighlightedText ? `${leadingHighlightedText} ` : ''}
                    <Text
                        is='span'
                        fontWeight='bold'
                        css={styles.keepWithInfoButton}
                    >
                        {lastHighlightedWord}
                        <InfoButton
                            isOutline
                            padding={0}
                            margin={0}
                            marginLeft={1}
                            onClick={this.handleInfoButtonClick}
                        />
                    </Text>
                </Text>
                {suffix}
            </>
        );
    };

    renderDisplayPasskeySummary = isDesktop => {
        return (
            <Text is='p'>
                {this.props?.passkeys?.length > 0
                    ? this.renderPasskeyHeader() || (
                        <>
                            {isDesktop ? getText('signInWithFaceFingerprintPin') : getText('signInWithFaceOrFingerprint')}
                            {isDesktop && <br />}
                            {isDesktop ? getText('orDevicePassword') : null}
                        </>
                    )
                    : getText('noPasskey')}
                {this.props?.passkeys?.length === 0 && (
                    <InfoButton
                        isOutline
                        padding={0}
                        margin={0}
                        marginLeft={1}
                        onClick={this.handleInfoButtonClick}
                    />
                )}
            </Text>
        );
    };

    render() {
        const { isEditMode } = this.props;

        const isDesktop = Sephora.isDesktop();

        const displayBlock = (
            <React.Fragment>
                <LegacyGrid
                    gutter={3}
                    data-at={Sephora.debug.dataAt('account_passkeys_field')}
                    alignItems='baseline'
                >
                    <LegacyGrid.Cell width={!isDesktop ? 85 : 1 / 4}>
                        <Text fontWeight='bold'>{getText('passkey')}</Text>
                    </LegacyGrid.Cell>

                    <LegacyGrid.Cell
                        width='fill'
                        paddingRight={0}
                    >
                        {this.renderDisplayPasskeySummary(isDesktop)}
                    </LegacyGrid.Cell>

                    {!Sephora.isAgent && this.props?.passkeys?.length > 0 ? (
                        <LegacyGrid.Cell
                            alignSelf={['flex-start', 'center']}
                            width='fit'
                            paddingLeft={0}
                        >
                            <Link
                                color='blue'
                                paddingY={2}
                                marginY={-2}
                                onClick={this.handleEditLinkClick}
                                data-at={Sephora.debug.dataAt('myaccount_edit_button')}
                            >
                                {getText('edit')}
                            </Link>
                        </LegacyGrid.Cell>
                    ) : !Sephora.isAgent && this.state.optinEnabled && !this.state.passkeyIdThisDevice ? (
                        <LegacyGrid.Cell
                            alignSelf={['flex-start', 'center']}
                            width='fit'
                            paddingLeft={0}
                        >
                            <Link
                                color='blue'
                                paddingY={2}
                                marginY={-2}
                                onClick={this.handleCreatePasskey}
                                data-at={Sephora.debug.dataAt('myaccount_create_button')}
                            >
                                {getText('createPasskey')}
                            </Link>
                        </LegacyGrid.Cell>
                    ) : null}
                </LegacyGrid>

                <Divider marginY={5} />
            </React.Fragment>
        );

        const editBlock = (
            <React.Fragment>
                <LegacyGrid
                    data-at={Sephora.debug.dataAt('account_passkeys_field')}
                    gutter={3}
                    alignItems='baseline'
                >
                    <LegacyGrid.Cell width={!isDesktop ? 85 : 1 / 4}>
                        <Text fontWeight='bold'>{getText('passkey')}</Text>
                    </LegacyGrid.Cell>

                    <LegacyGrid.Cell width='fill'>
                        <Text
                            is='p'
                            marginBottom={4}
                        >
                            {this.renderPasskeyHeader() || (
                                <>
                                    {isDesktop ? getText('signInWithFaceFingerprintPin') : getText('signInWithFaceOrFingerprint')}
                                    {isDesktop ? <br /> : null}
                                    {isDesktop ? getText('orDevicePassword') : null}
                                </>
                            )}
                        </Text>

                        {passkeysUtils.isPasskeyEnabled() ? (
                            <>
                                <Media lessThan='md'>{this.renderPasskeys(this.props?.passkeys)}</Media>
                                <Media greaterThanOrEqual='md'>
                                    {[this.renderPasskeys(this.props?.passkeys), this.renderCancelButton(), this.renderCreateButton()]}
                                </Media>
                            </>
                        ) : (
                            isDesktop && [this.renderPasskeys(this.props?.passkeys), this.renderCancelButton()]
                        )}
                    </LegacyGrid.Cell>
                </LegacyGrid>

                {passkeysUtils.isPasskeyEnabled() ? (
                    <Media lessThan='md'>{[this.renderCancelButton(), this.renderCreateButton()]}</Media>
                ) : (
                    !isDesktop && (
                        <LegacyGrid.Cell width='fill'>{[this.renderPasskeys(this.props?.passkeys), this.renderCancelButton()]}</LegacyGrid.Cell>
                    )
                )}

                <Divider marginY={5} />
            </React.Fragment>
        );

        return isEditMode ? editBlock : displayBlock;
    }
}

const styles = {
    keepWithInfoButton: {
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    }
};

export default wrapComponent(AccountPasskeys, 'AccountPasskeys');
